import { firebase } from "@firebase/app";
import "@firebase/firestore";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyCoRzL4i8_4usWGfG8hCSQT2m2f0U_rEbo",
  authDomain: "jackie-serviss.firebaseapp.com",
  databaseURL: "https://jackie-serviss.firebaseio.com",
  projectId: "jackie-serviss",
  storageBucket: "jackie-serviss.appspot.com",
  messagingSenderId: "943985493218",
  timestampsInSnapshots: true
});

export const db = firebaseApp.firestore();

// db.settings(settings);


// WEBPACK FOOTER //
// ./src/firebase.js